import { Component} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';

@Component({
  selector: 'app-register-payment',
  templateUrl: './register-payment.component.html',
  styleUrls: ['./register-payment.component.scss'],
  imports: [CommonModule, MapfreDesignLibraryModule, ]
})
export class RegisterPaymentComponent {}
